import safeRegex from "safe-regex";

function safeRegExp(pattern: RegExp, name: string): RegExp {
  const regex = new RegExp(pattern);
  if (!safeRegex(regex)) {
    console.warn(
      `Regex ${name} is considered unsafe by safe-regex, but allowed manually.`,
    );
  }
  return regex;
}

export const NO_SPECIAL_CHARS = safeRegExp(
  /^[a-zA-ZÀ-ž0-9 ]+$/gi,
  "NO_SPECIAL_CHARS",
);
export const NO_SPECIAL_CHARS_NAME = safeRegExp(
  /^[a-zA-ZÀ-ž0-9 '’-]+$/gi,
  "NO_SPECIAL_CHARS_NAME",
);
export const NO_SPECIAL_CHARS_AND_SPACE = safeRegExp(
  /^[a-zA-ZÀ-ž0-9]+$/gi,
  "NO_SPECIAL_CHARS_AND_SPACE",
);
export const TWO_WORDS_AT_LEAST = safeRegExp(
  /^\s*\S+\s+\S+.*$/,
  "TWO_WORDS_AT_LEAST",
);

export const BANK_ACCOUNT_NUMBER = safeRegExp(
  /^(?!0+$)[0-9]{1,20}([-]?)?$/,
  "BANK_ACCOUNT_NUMBER",
);
